// extracted by mini-css-extract-plugin
module.exports = {"container":"_1TxxW6hOI0cL2C5tzrhIZ_"};